import * as httpTool from '../http-tools'
import * as apiConst from '../api-const'
export default {
    memberList(params) {
        return httpTool.fetchPost(apiConst.member_listUrl, params)
    },
    memberDetail(params) {
        return httpTool.fetchPost(apiConst.detial_memberUrl, params)
    },
    leaveCustom(params) {
        return httpTool.fetchPost(apiConst.leaveMemberUrl, params)
    },

    getBatchList(params, tableId) {
        if (tableId == 3 || tableId == 4 || tableId == 1 || tableId == 7) {
            return httpTool.fetchPost(apiConst.getBatchBabyHeathRecordList, params)
        } else {
            return httpTool.fetchPost(apiConst.getBatchMatarnalHeathRecordList, params)
        }
    },
    getBatchMatarnalHeathRecordList(params) {
        return httpTool.fetchPost(apiConst.getBatchMatarnalHeathRecordList, params)
    },
    getBatchBabyHeathRecordList(params) {
        return httpTool.fetchPost(apiConst.getBatchBabyHeathRecordList, params)
    },
    
    batchAddBabyNursOne(params) {
        return httpTool.fetchPost(apiConst.batchAddBabyNursOne, params)
    },
    batchAddBabyNursTwo(params) {
        return httpTool.fetchPost(apiConst.batchAddBabyNursTwo, params)
    },
    batchHeathRecord(params) {
        return httpTool.fetchPost(apiConst.batchHeathRecord, params)
    },
    batchAddMaternalEverydayPhysiology(params) {
        
        return httpTool.fetchPost(apiConst.batchAddMaternalEverydayPhysiology, params)
    },
    batchAddMaterRehNursEvalData(params) {
        return httpTool.fetchPost(apiConst.batchAddMaterRehNursEvalData, params)
    },
    batchMatarnalHeathRecord(params) {
        return httpTool.fetchPost(apiConst.batchMatarnalHeathRecord, params)
    },
    batchBabyHeathRecord(params) {
        return httpTool.fetchPost(apiConst.batchBabyHeathRecord, params)
    },

    batchAddBabyCareOpera(params) {
        return httpTool.fetchPost(apiConst.batchAddBabyCareOpera, params)
    },

    batchHeathRecordDetail(params) {
        return httpTool.fetchPost(apiConst.batchHeathRecordDetail, params)
    }
};


// WEBPACK FOOTER //
// ./src/service/api/repository/memberList-api.js